import { OverlayContainer } from '@angular/cdk/overlay';
import { ApplicationService } from 'services/application/application.service';
var AppModule = /** @class */ (function () {
    function AppModule(overlayContainer, appSvc) {
        this.overlayContainer = overlayContainer;
        this.appSvc = appSvc;
        appSvc.ThemeSubject.subscribe(function (value) {
            if (value) {
                overlayContainer.getContainerElement().classList.add('dark-iris');
            }
            else {
                overlayContainer.getContainerElement().classList.remove('dark-iris');
            }
        });
    }
    return AppModule;
}());
export { AppModule };
